import React from 'react';
import SynapseNews from '../../../Journal';
import marathon from '../../../../assets/conference/marathon.png';
import article from '../../../../assets/conference/article.jpg';

const JournalSlide = ({ slide, slideKey, focusClimate: focusClimateProp }) => {
    // Use prop if provided, otherwise fall back to slide data
    const focusClimate = focusClimateProp !== undefined ? focusClimateProp : (slide.focusClimate || false);

    return (
        <div key={slideKey} className="w-full h-full p-4 animate-fade-in">
            <SynapseNews
                title={slide.title}
                articles={slide.articles.map(art => ({
                    ...art,
                    imageUrl: art.imageUrl === "marathon" ? marathon : (art.imageUrl === "article" ? article : art.imageUrl)
                }))}
                guerres={slide.guerres}
                playerCountry={slide.playerCountry}
                isSlide={true}
                focusClimate={focusClimate}
                onClose={() => { }}
                backChoice={() => { }}
            />
        </div>
    );
};

export default JournalSlide;
